import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    FiPower,
    FiShoppingCart,
    FiShoppingBag,
    FiShare,
    FiBarChart2,
    FiHome,
    FiMenu,
    FiSettings
} from 'react-icons/fi';
import { FaCalculatorAlt, FaDollarSign } from 'react-icons/fa';
import { ReactComponent as Logo } from '../../assets/img/default/logo.svg';
import { ReactComponent as LogoText } from '../../assets/img/default/logo-text.svg';
import qrCode from '../../assets/img/default/qr-code.svg';
import lang from './lang';
import './Sidebar.css';

class Sidebar extends Component {
    state = { fullWidth: 'compact' }
    componentDidMount() {
        if (window.outerWidth < 991) {
            this.setState({ fullWidth: 'compact' })
        }
    }
    sideBarHandler = () => {
        const { fullWidth } = this.state;
        this.setState({ fullWidth: fullWidth ? '' : 'compact' })
    }

    sideBarLinkHandler = () => {
        if (window.outerWidth < 600) {
            this.setState({ fullWidth: 'compact' })
        }
    }
    render() {
        const { analysis, dashboard, expenses, products, sale, scanner, inventory, currency } = lang[this.props.lang || 'en'];
        let navBar = "";
        if (this.props.auth.isAdmin) {
            navBar = (
                <nav className="nav flex-column">
                    <NavLink
                        to="/"
                        exact
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                    >
                        <FiHome className="mr-2" />
                        <span className="nav-text">{dashboard}</span>
                    </NavLink>
                    <NavLink
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                        to="/sales"
                    >
                        <FiShoppingCart className="mr-2" />
                        <span className="nav-text">{sale}</span>
                    </NavLink>
                    <NavLink
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                        to="/products"
                    >
                        <FiShoppingBag className="mr-2" />
                        <span className="nav-text">{products}</span>
                    </NavLink>
                    <NavLink
                        exact
                        to="/scanner"
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                    >
                        <img src={qrCode} alt="qr-code" width="20" className="" />
                        <span className="nav-text ml-2">{scanner}</span>
                    </NavLink>
                    {/* <NavLink
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                        to="/payments"
                    >
                        <FaWallet className="mr-2" />
                        <span className="nav-text">{payments}</span>
                    </NavLink> */}
                    <NavLink
                        to="/expenses"
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                    >
                        <FiShare className="mr-2" />
                        <span className="nav-text">{expenses}</span>
                    </NavLink>
                    <NavLink
                        to="/inventory-count"
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                    >
                        <FaCalculatorAlt className="mr-2" />
                        <span className="nav-text">{inventory}</span>
                    </NavLink>
                    <NavLink
                        to="/currency"
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                    >
                        <FaDollarSign className="mr-2" />
                        <span className="nav-text">{currency}</span>
                    </NavLink>
                    <NavLink
                        to="/analytics"
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                    >
                        <FiBarChart2 className="mr-2" />
                        <span className="nav-text">{analysis}</span>
                    </NavLink>
                    {
                        this.props.auth.userType === 'admin'
                        &&
                        <NavLink
                            to="/settings"
                            activeClassName="nav-active"
                            className="nav-item"
                            onClick={this.sideBarLinkHandler}
                        >
                            <FiSettings className="mr-2" />
                            <span className="nav-text">{"Settings"}</span>
                        </NavLink>
                    }

                    <button onClick={() => this.props.signout()} className="btn btn-danger sign-out-btn mt-auto"> <FiPower style={{ strokeWidth: '2px' }} /></button>
                </nav>
            )
        } else {
            navBar = (
                <nav className="nav flex-column">
                    <NavLink
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                        to="/sales"
                    >
                        <FiShoppingCart className="mr-2" />
                        <span className="nav-text">{sale}</span>
                    </NavLink>

                    <NavLink
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                        to="/products"
                    >
                        <FiShoppingBag className="mr-2" />
                        <span className="nav-text">{products}</span>
                    </NavLink>

                    <NavLink
                        activeClassName="nav-active"
                        className="nav-item"
                        onClick={this.sideBarLinkHandler}
                        to="/scanner" exact
                    >
                        <img src={qrCode} alt="qr-code" width="20" className="mr-2" />
                        <span className="nav-text">{scanner}</span>
                    </NavLink>

                    <button
                        onClick={() => this.props.signout()}
                        className="btn btn-danger sign-out-btn mt-auto"
                    >
                        <FiPower />
                    </button>
                </nav>
            )
        }
        return (
            <React.Fragment>
                <header className={`navbar ${this.state.fullWidth}`}>
                    {
                        navBar
                    }
                </header>
                <span
                    id="toggle-btn"
                    className="menu-btns"
                    onClick={this.sideBarHandler}
                >
                    {/* {this.state.fullWidth === 'compact' ? <FiBarChart2 color="black" /> : <FiBarChart color="black" />} */}
                    <FiMenu />
                </span>
                <div id="logo-area">
                    <Link to="/">
                        <Logo width={35} height={35} id="logo" />
                        <LogoText width={100} id="logo-long" />
                    </Link>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth
    }
}
export default connect(mapStateToProps)(Sidebar);